import { Directive } from '@angular/core';

@Directive({
  selector: '[libListItemDef]',
  standalone: true
})
export class ListItemDefDirective {}
